import _ from 'lodash';
import { Component, forwardRef, Input, ViewChild, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToastService } from 'app/toast/services/toast.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone:true,
  imports:[CommonModule],
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputFileComponent),
    multi: true,
  }],
})
export class InputFileComponent implements ControlValueAccessor {
  @ViewChild('field') field: ElementRef;

  @Input() label: string = null;
  @Input() accept: string = "image/*";
  @Input() multiple: boolean = false;

  @Input() classes: string[] = [];
  @Input() minSize: number = null;

  public value = null;

  @Input()
  public disabled = false;
  public _disabled = false;

  constructor(
    private store: Store,
    private toastService: ToastService
  ) {}

  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }

  writeValue(value: any) {
		if ( value instanceof FileList ) {
			this.value = value;
		} else if ( value === null ) {
			this.value = null;
		} else {
			// Since we cannot manually construct a FileList instance, we have to ignore
			// any attempt to push a non-FileList instance into the input.
			if (console && console.warn && console.log) {
				console.warn("Ignoring attempt to assign non-FileList to input[type=file].");
				console.log("Value:", value);
			}
		}
  }

  setDisabledState(isDisabled: boolean) {
    this._disabled = isDisabled;
  }

  onChange(event: any) {
      const files = _.get(event, 'target.files', []);
      if(files.length > 1) {
        const list = _.map(files, file => file);
        this.onChangeCallback(list);
      } else if(files.length > 0) {    
        if(this.minSize){
          this.getImageDimensions(files[0]).then(dimensions => {
            if(dimensions.width < this.minSize || dimensions.height < this.minSize){
              this.onChangeCallback('size error');
            }else{
              this.onChangeCallback(files[0]);
            }
            console.log(`File: ${files[0].name}, Width: ${dimensions.width}, Height: ${dimensions.height}`);
          }).catch(error => {
            console.error(`Error reading file: ${files[0].name}, ${error}`);
          });
        }else{
          this.onChangeCallback(files[0]);
        }
      } else {
        this.onChangeCallback(null);
      }
  }

  onClick() {
    this.field.nativeElement.value = null;
    this.onChangeCallback(null);
  }

  getClassList() {
    const classes = _.chain(this.classes).map(value => { 
      return {
        key: value,
        value: true
      };
    }).keyBy('key').mapValues('value').value();
    const result = {
      ...classes,
      'btn--disabled': this.disabled
    }
    return result;
  }

  getImageDimensions(file: File): Promise<{width: number, height: number}> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = reject;
        img.src = e.target.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
}